import Sidebar from "@/components/Sidebar";
import { useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import ForcePasswordChangeModal from "@/components/ForcePasswordChangeModal";

export default function AppShell({ children }) {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-zinc-100 grid-bg">
      <Sidebar />
      <main className="ml-64 min-h-screen">
        <div className="px-8 py-8 fade-in">{children}</div>
      </main>
      {user?.must_change_password && <ForcePasswordChangeModal />}
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          className: "border border-zinc-800 bg-[#121212] text-white",
        }}
      />
    </div>
  );
}
